import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import Export from "../../component/Export";
import Swal from "sweetalert2";
import TableViewer from "../../component/tableViewer/TableViewer";
import moment from "moment";
import DonutChartWithLabel from "../../component/chart/donut/DonutChartWithLabel";

const ViewTestResults = () => {
  const { sid, sname, cid, cname, ctype } = useParams();
  const token = config.token;
  const [loading, setLoading] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const navigate = useNavigate();

  const [allTestResults, setAllTestResults] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [resultTitle, setResultTitle] = useState("");
  const [testDate, setTestDate] = useState("");
  const [testResult, setTestResult] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [mcqBanks, setMcqBanks] = useState([]);
  const [selectedMcqBank, setSelectedMcqBank] = useState("");
  const [mcqs, setmcqs] = useState([]);
  const [selectedmcq, setSelectedmcq] = useState("");
  const [sections, setSections] = useState([]);

  //  ------For TableViewer ------
  const allTestResultsRef = useRef([]);
  allTestResultsRef.current = allTestResults;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  const optionHead = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
  ];

  useState(() => {
    console.log("rowData: ", rowData.data);
  }, [rowData]);
  const handleSelectedMcqBank = (e) => {
    setSelectedMcqBank(e.target.value);
    console.log("selectedMcqBank", selectedMcqBank);
  };
  const handleSelectedMcq = (e) => {
    setSelectedmcq(e.target.value);
  };
  //-------------------------------------- read / fetch all results of student --------------------------------R
  const fetchStudentAllTestResults = async (id) => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}pages/${
          ctype === "course"
            ? "course-wise-result/"
            : ctype === "chapter"
            ? "chapter/chapter-wise-result/"
            : "myexams?studentid="
        }${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            const responseData = data.data;
            await setAllTestResults(responseData);

            //  ------For TableViewer ------
            const allTestResultsData = data.data.map((testResult) => ({
              date: moment(testResult.completed_at).format("Do MMM 'YY"),
              course_chapter: testResult.name === null ? "Course" : "Chapter",
              student_name: testResult.first_name + " " + testResult.last_name,
              bank_name: testResult.bank_name,
              mcq_round: testResult.mcq_round,
              course_chapter_name:
                testResult.name !== null
                  ? testResult.name
                  : testResult.course_name,
              idNumber: testResult.seid,
            }));
            console.log("allTestResultsData: ", allTestResultsData);
            setRowData(allTestResultsData);
            //  ------For TableViewer ------
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };
  const getQuestions = (id) => {
    try {
      fetch(`${config.host_url}mcq?mbid=${id}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setSections(data.sections);
            setmcqs(data.data);
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated user");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching data");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (sid !== undefined) {
      fetchStudentAllTestResults(sid);
    }
  }, [sid]);

  useEffect(() => {
    if (cid !== undefined) {
      fetch(
        `${config.host_url}mcqbanks/course/${decodeURIComponent(atob(cid))}`,
        {
          method: "GET",
          headers: {
            token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setMcqBanks(data.data);
        });
      fetchStudentAllTestResults(cid);
    }
  }, [cid]);
  //fetch data
  useEffect(() => {
    getQuestions(selectedMcqBank);
  }, [selectedMcqBank]);
  //----------------------------------------- Show / Get Result ----------------------------------R
  // const handleMarkCorrectBtn = async (secInd, queInd, mcqId, sedid) => {
  const handleMarkCorrectBtn = async (data, title, date) => {
    setLoading(true);
    try {
      console.log(data);
      await fetch(
        `${config.host_url}mcq/mark-as-correct?mcqid=${data.mcqid}&sedid=${data.sedid}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then(async (r) => {
          if (r.status === 200) {
            showResult(data.seid, title, date);
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };

  //----------------------------------------- Show / Get Result ----------------------------------R
  const showResult = async (seid, rTitle, rDate) => {
    setResultTitle(rTitle);
    setTestDate(rDate);

    setPopupLoading(true);
    try {
      await fetch(`${config.host_url}pages/result/${seid}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            const responseData = data.data;
            setSectionList(data.sections);
            setTestResult(responseData);
            setQuestions(responseData);
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setPopupLoading(false);
    }
  };
  const onSubmit = async () => {
    await fetch(`${config.host_url}mcq/correction?mcqid=${selectedmcq}`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then(async (r) => {
        if (r.status == 200) {
          triggerNotification("success", "Correction updated successfully.");
        }
      });
  };

  const result = sectionList.reduce(
    (acc, section) => {
      const sectionResult = testResult[section]?.reduce(
        (sectionAcc, item) => {
          if (item.isCorrect) {
            sectionAcc.acc += item.positive_mark;
            sectionAcc.posMark += item.positive_mark;
          } else if (!item.isCorrect && item.status !== 2) {
            sectionAcc.acc -= item.negative_mark;
            sectionAcc.negMark += item.negative_mark;
          } else {
            console.log("skiped: ", item.status);
          }
          return sectionAcc;
        },
        { acc: 0, posMark: 0, negMark: 0 }
      ) || { acc: 0, posMark: 0, negMark: 0 };

      acc.acc += sectionResult.acc;
      acc.posMark += sectionResult.posMark;
      acc.negMark += sectionResult.negMark;

      return acc;
    },
    { acc: 0, posMark: 0, negMark: 0 }
  );

  const obtainedMarks = result.acc;
  const posMark = result.posMark;
  const negMark = result.negMark;
  console.log("obtainedMarks: ", obtainedMarks);
  const totalPositiveMarks = sectionList.reduce((acc, section) => {
    return (
      acc +
      testResult[section].reduce((sectionAcc, question) => {
        return sectionAcc + question.positive_mark;
      }, 0)
    );
  }, 0);

  const wrongAns = sectionList.reduce((acc, section) => {
    return (
      acc +
      (testResult[section]?.reduce((acc, item) => {
        if (!item.isCorrect) {
          acc++;
        }
        return acc;
      }, 0) || 0)
    );
  }, 0);
  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      field: "date",
      filter: true,
      valueFormatter: (params) => {
        return params.value === "Invalid date" ? "NA" : params.value;
      },
    },
    ...(cid
      ? [
          { headerName: "Student Name", field: "student_name", filter: true },
          {
            headerName: "Bank Name",
            field: "bank_name",
            filter: true,
            width: 250,
          },
          {
            headerName: "Round",
            field: "mcq_round",
            filter: true,
            width: 100,
            cellRenderer: (params) => (
              <p className="flex justify-center">{params.data.mcq_round}</p>
            ),
          },
        ]
      : []),
    ...(!cid
      ? [
          {
            headerName: "Course or Chapter",
            field: "course_chapter",
            filter: true,
          },
          {
            headerName: "Course or Chapter Name",
            field: "course_chapter_name",
            filter: true,
            width: 350,
          },
        ]
      : []),
    {
      headerName: "Actions",
      field: "action",
      cellRenderer: (params) => (
        <div>
          <button
            type="button"
            className="btn  btn-secondary m-2"
            onClick={() => {
              showResult(
                params.data.idNumber,
                cid
                  ? params.data.student_name
                  : params.data.course_chapter_name,
                params.data.date
              );
            }}
            data-bs-toggle="modal"
            data-bs-target="#ViewResult"
          >
            Show
          </button>
        </div>
      ),
    },
  ];

  //--------------------- Chart Data -----------------------
  const resultData = [
    {
      label: "Pass",
      value: 40,
    },
    {
      label: "Fail",
      value: 50,
    },
  ];
  const attendData = [
    {
      label: "Non-Attendees",
      value: 40 - 10,
    },
    {
      label: "Attendees",
      value: 10,
    },
  ];
  //  ------For TableViewer ------
  return (
    <>
      {ctype && ctype === "course" ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={["View Courses", "Test Results"]}
          url={["/viewcourses"]}
        />
      ) : ctype && ctype === "chapter" ? (
        <Breadcrumb
          txt="Manage Chapter"
          subpath={["View Chapters", "Test Results"]}
          url={["/viewchapters"]}
        />
      ) : (
        <Breadcrumb
          txt="Manage Student"
          subpath={["View Students", "Student Details", "Test Results"]}
          url={["/viewstudents", `/viewstudent/${sid}`]}
        />
      )}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center row flex justify-between">
            <h5 className="mb-0 col-md-9">
              Test Results{" "}
              {"(" + decodeURIComponent(atob(sname ? sname : cname)) + ")"}
            </h5>
            <div className="col-sm-3 flex justify-end mt-2">
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  ctype && ctype === "course"
                    ? navigate(`/viewcourses`)
                    : ctype && ctype === "chapter"
                    ? navigate(`/viewchapters`)
                    : navigate(`/viewstudent/${sid}`);
                }}
              >
                {"<"} back
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card mb-4 mx-4">
              <div className="card-header p-0">
                <div className="nav-align-top">
                  <ul className="nav nav-tabs" role="tablist">
                    {/* overview tab btn */}
                    {ctype === "course" && (
                      <li className="nav-item">
                        <button
                          type="button"
                          className={`nav-link active`}
                          role="tab"
                          data-bs-toggle="tab"
                          data-bs-target={`#navs-top-ovrvw`}
                          aria-controls={`navs-top-ovrvw`}
                          aria-selected={true}
                        >
                          overview
                        </button>
                      </li>
                    )}

                    {/* View Result tab btn */}
                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${ctype !== "course" && "active"}`}
                        role="tab"
                        data-bs-toggle="tab"
                        data-bs-target={`#navs-top-vwrslt`}
                        aria-controls={`navs-top-vwrslt`}
                        aria-selected={false}
                      >
                        View Result
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card-body">
                <div className="tab-content p-0">
                  {/* overview tab card */}
                  {ctype === "course" && (
                    <div
                      className={`tab-pane fade show active `}
                      id={`navs-top-ovrvw`}
                      role="tabpanel"
                    >
                      <div className="row">
                        <div className="col-lg-12 ">
                          <div className="card">
                            {/* <div className="card-header"></div> */}
                            <div className="card-body">
                              <h6>Correction</h6>
                              <div className="col-md-12 mt-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <select
                                    className="form-select mx-auto"
                                    id="chapterdropdown"
                                    aria-label="chapterdropdown"
                                    value={selectedMcqBank}
                                    onChange={handleSelectedMcqBank}
                                  >
                                    <option
                                      value=""
                                      disabled
                                      selected
                                      className="text-center"
                                    >
                                      --- Select MCQ Bank ---
                                    </option>
                                    {mcqBanks?.map((mcqBank) => (
                                      <option
                                        key={mcqBank.mbid}
                                        value={mcqBank.mbid}
                                      >
                                        {mcqBank.bank_name}
                                      </option>
                                    ))}
                                  </select>
                                  <label htmlFor="chapterdropdown">
                                    MCQ Banks
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-12 mt-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <select
                                    className="form-select mx-auto"
                                    id="mcqdropdown"
                                    aria-label="mcqdropdown"
                                    value={selectedmcq}
                                    onChange={handleSelectedMcq}
                                  >
                                    <option
                                      value=""
                                      disabled
                                      selected
                                      className="text-center"
                                    >
                                      --- Select MCQ ---
                                    </option>
                                    {sections?.map((section) => (
                                      <optgroup label={section}>
                                        {mcqs[section]?.map((mcq, i) => (
                                          <option
                                            key={mcq.mcqid}
                                            value={mcq.mcqid}
                                          >
                                            {i + 1}. {mcq.que}
                                          </option>
                                        ))}
                                      </optgroup>
                                    ))}
                                  </select>
                                  <label htmlFor="chapterdropdown">MCQ</label>
                                </div>
                              </div>
                              <button
                                onClick={onSubmit}
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-8 mb-2"
                              >
                                Submit
                              </button>
                            </div>
                            {/* <div className="card-footer"></div> */}
                          </div>
                        </div>
                        <div className="col-md-6 mt-4  ">
                          <div
                            className="border rounded p-3 "
                            style={{ height: "373px" }}
                          >
                            <h6 className="mb-0">Exam Success Rate</h6>
                            <DonutChartWithLabel data={resultData} />
                          </div>
                        </div>
                        <div className="col-md-6 mt-4  ">
                          <div
                            className="border rounded p-3"
                            style={{ height: "373px" }}
                          >
                            <h6 className="mb-0">Exam Participation Rate</h6>
                            <DonutChartWithLabel
                              data={attendData}
                              totalStd={40}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* View Result tab card */}
                  <div
                    className={`tab-pane fade ${
                      ctype !== "course" && "show active"
                    } `}
                    id={`navs-top-vwrslt`}
                    role="tabpanel"
                  >
                    {/* ------For TableViewer ------ */}
                    <TableViewer
                      rowData={rowData}
                      colDefs={colDefs}
                      // onView={showResult}
                    />
                    {/* ------For TableViewer ------ */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* view result popup */}
      <div
        className="modal fade"
        id="ViewResult"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content pt-2 pb-5 px-md-5">
            <div className="modal-header flex mb-4 justify-end">
              <h5 className="mb-0">
                {" "}
                Result - {cid ? decodeURIComponent(atob(cname)) : resultTitle}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <hr />

            <div className="modal-body p-md-0">
              {popupLoading ? (
                <Spinner />
              ) : (
                <>
                  <div className="flex justify-center">
                    <div className="card w-96 py-8 ">
                      <div className="flex justify-center">
                        <h1
                          className={`border-2 border-blue-600 rounded-full m-2 py-10 px-9 text-blue-600`}
                        >
                          <sup>{obtainedMarks}</sup>/
                          <sub>{totalPositiveMarks}</sub>
                        </h1>
                      </div>
                      <div className="flex justify-center  mt-3">
                        <div>
                          <h5>
                            {cid
                              ? resultTitle
                              : decodeURIComponent(atob(sname ? sname : cname))}
                          </h5>
                          <hr />
                          <div className=" flex">
                            <h6 className="mr-2 ">Completed At:</h6>
                            <h6 className="text-slate-950/50">{testDate}</h6>
                          </div>

                          <div className=" flex">
                            <h6 className="mr-2 ">Right Answers:</h6>
                            <h6 className="text-slate-950/50 text-green-500">
                              {posMark}
                            </h6>
                          </div>
                          <div className=" flex">
                            <h6 className="mr-2 ">Wrong Answers:</h6>
                            <h6 className="text-slate-950/50 text-red-500">
                              {negMark}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="col-lg-12">
                    {sectionList && sectionList.length > 0 ? (
                      <div className="card mb-4">
                        <div className="card-header p-0">
                          <div className="nav-align-top">
                            <ul className="nav nav-tabs" role="tablist">
                              {sectionList.map((section, i) => (
                                <li className="nav-item" key={i}>
                                  <button
                                    type="button"
                                    className={`nav-link ${
                                      i === 0 && "active"
                                    }`}
                                    role="tab"
                                    data-bs-toggle="tab"
                                    data-bs-target={`#navs-top-${section}`}
                                    aria-controls={`navs-top-${section}`}
                                    aria-selected={i === 0 ? "true" : "false"}
                                  >
                                    {section}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="tab-content p-0">
                            {sectionList.map((section, index) => (
                              <div
                                key={index}
                                className={`tab-pane fade ${
                                  index === 0 && "show active"
                                } `}
                                id={`navs-top-${section}`}
                                role="tabpanel"
                              >
                                {/* -------- */}
                                {questions[section]?.map((question, i) => (
                                  <div key={i}>
                                    <div className="flex item-center">
                                      <div>
                                        <i
                                          className={`menu-icon text-${
                                            question.ans ===
                                            question.student_ans
                                              ? "green-500"
                                              : question.status === 2
                                              ? "warning"
                                              : "red-500"
                                          } tf-icons mdi ${
                                            question.ans ===
                                            question.student_ans
                                              ? "mdi-checkbox-marked-outline"
                                              : question.status === 2
                                              ? "mdi-alert-box-outline"
                                              : "mdi-close-box-outline"
                                          } col ml-4`}
                                          data-toggle="tooltip"
                                          title="result"
                                        ></i>
                                      </div>
                                      <h5 className="select-none">{i + 1}.</h5>
                                      &nbsp;
                                      <h5 className="select-none">
                                        {question.que.replace(
                                          /\{dash\}/g,
                                          "__________"
                                        )}
                                      </h5>
                                    </div>
                                    {question.explanation && (
                                      <div className="flex select-none ml-14 ">
                                        <h6 className="mr-2">Explanation :</h6>
                                        <h6 className="text-slate-950/50">
                                          {question.explanation}
                                        </h6>
                                      </div>
                                    )}
                                    <div className="ml-14 ">
                                      <div className="row">
                                        {question &&
                                          question.options &&
                                          question.options.map((option, j) =>
                                            option ? (
                                              <p
                                                className="col-md-6 flex pr-28"
                                                key={j}
                                              >
                                                <span className="mr-2 pb-0 mb-0 ">
                                                  {optionHead[j]}
                                                  {") "}
                                                </span>
                                                {option}
                                              </p>
                                            ) : (
                                              ""
                                            )
                                          )}
                                        <span className="flex  pl-0">
                                          <h6 className="mr-2">
                                            Right Answer :
                                          </h6>
                                          <h6 className="text-slate-950/50">
                                            {question.ans &&
                                              question.ans
                                                .replace(/\@\#\$/g, "  => ")
                                                .replace(/\$\#\@/g, " | ")}
                                          </h6>
                                        </span>
                                        <span className="flex  pl-0">
                                          <h6 className="mr-2">
                                            Student Answer :
                                          </h6>
                                          <h6 className="text-slate-950/50">
                                            {question.student_ans &&
                                              question.student_ans
                                                .replace(/\@\#\$/g, "  => ")
                                                .replace(/\$\#\@/g, " | ")}
                                          </h6>
                                        </span>
                                        <span className="flex mt-0 pl-0">
                                          <h6 className="mr-2">
                                            Question Type :
                                          </h6>
                                          <h6 className="text-slate-950/50">
                                            {question.que_type}
                                          </h6>
                                        </span>
                                        <span>
                                          <div className="row">
                                            <div className="flex col-md-4">
                                              <h6 className="mr-2">
                                                Positive Mark :
                                              </h6>
                                              <h6 className="text-slate-950/50">
                                                {question.positive_mark}
                                              </h6>
                                            </div>
                                            <div className="flex col-md-4">
                                              {" "}
                                              <h6 className="mr-2">
                                                Negative Mark :
                                              </h6>
                                              <h6 className="text-slate-950/50">
                                                {question.negative_mark}
                                              </h6>
                                            </div>
                                            <div className="flex col-md-4">
                                              {" "}
                                              <h6 className="mr-2">
                                                Obtained Mark :
                                              </h6>
                                              <h6 className="text-slate-950/50">
                                                {question.isCorrect
                                                  ? question.positive_mark
                                                  : question.status === 2
                                                  ? "0"
                                                  : "-" +
                                                    question.negative_mark}
                                              </h6>
                                            </div>
                                          </div>
                                        </span>
                                        {/* mark as correct */}

                                        {question.ans !=
                                          question.student_ans && (
                                          <div className="">
                                            <div
                                              className="py-1 text-[#209444]  border-[#209444] border-1 hover:bg-green-200  px-2 mb-4 w-40  rounded"
                                              onClick={
                                                () =>
                                                  handleMarkCorrectBtn(
                                                    question,
                                                    cid
                                                      ? resultTitle
                                                      : decodeURIComponent(
                                                          atob(
                                                            sname
                                                              ? sname
                                                              : cname
                                                          )
                                                        ),
                                                    testDate
                                                  )
                                                // handleMarkCorrectBtn(
                                                //   index,
                                                //   i,
                                                //   question.mcqid,
                                                //   question.sedid
                                                // )
                                              }
                                            >
                                              <span className="mdi mdi-check  mr-2"></span>
                                              Mark as correct
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <hr />
                                  </div>
                                ))}
                                {/* ============= */}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p className="text-center">
                        There are currently no questions available within this
                        exam.
                      </p>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewTestResults;
